window.DRKALLA_HAIR_ANALYSIS = {
  "generatedAt": "2026-07-11T13:49:59.896Z",
  "source": "Shopify product audit with live Storefront URL validation",
  "products": [
    {
      "title": "10-in-1 Spray Maske & Feuchtigkeit & Reparatur & Glanz 200ml",
      "url": "/products/10-in-1-spray-maske-feuchtigkeit-reparatur-200ml",
      "groups": [
        "mask",
        "leaveIn",
        "moisture",
        "repair",
        "colorCare",
        "coloring",
        "stylingHold",
        "volume",
        "frizzSmoothing"
      ],
      "available": true,
      "minPrice": 6.9,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/10-in-1-spray-mask-200-ml-black-professional-line-d7bfbf905b-drkalla-main-2048.png?v=1779202034",
        "alt": "Black Professional Line 10 in 1 Spray Maske – Leave-In Haarpflege mit Keratin - Haarpflege"
      },
      "caution": true
    },
    {
      "title": "Oxidationsmittel Farbentwickler & Blondierung Profi-Qualität",
      "url": "/products/oxidationsmittel-farbentwickler-blondierung-salonbedarf",
      "groups": [
        "antiYellow",
        "colorCare",
        "coloring",
        "bleach",
        "developer",
        "permChemical",
        "stylingHold",
        "scalp"
      ],
      "available": true,
      "minPrice": 4.49,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/75e11081-0b15-4d94-9c83-5910bb727691-1000x1000-8lTfgd36x6R5ja6aOUF7SuQJ93buujBw2JdNPbk6.webp?v=1778502815",
        "alt": "Black Professional Oxidant Farbentwickler Blondierung Salonqualität"
      },
      "caution": true
    },
    {
      "title": "Locken Maske & Frizz-Kontrolle mit Bio-Baobaböl",
      "url": "/products/curly-dream-maske-locken-bio-baobaoel-frizz-kontrolle",
      "groups": [
        "cleansing",
        "mask",
        "moisture",
        "repair",
        "stylingHold",
        "curl",
        "scalp",
        "frizzSmoothing"
      ],
      "available": true,
      "minPrice": 7.6,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/black-rose-curly-dream-maschera-1000ml-442x442_1.jpg?v=1780137247",
        "alt": "Black Professional Line Rose Curly Dream Mask 1000ml Lockenmaske"
      },
      "caution": false
    },
    {
      "title": "Locken Shampoo & Frizz-Kontrolle mit Bio-Baobaböl",
      "url": "/products/curly-dream-shampoo-locken-bio-baobaoel-frizz-kontrolle",
      "groups": [
        "cleansing",
        "mask",
        "moisture",
        "repair",
        "stylingHold",
        "curl",
        "scalp",
        "frizzSmoothing"
      ],
      "available": true,
      "minPrice": 7.6,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/3D1D9978-8ED6-4634-ADC4-FF7A6ED66FEB.jpg?v=1780139292",
        "alt": "Black Professional Line Curly Dream Shampoo 1000 ml Locken Bio-Baobaböl"
      },
      "caution": false
    },
    {
      "title": "Pflegemaske Trockenes & Feines Haar Bio-Hafer Volumen 500ml",
      "url": "/products/pflegemaske-trockenes-feines-haar-bio-hafer-volumen-500ml",
      "groups": [
        "cleansing",
        "mask",
        "moisture",
        "repair",
        "stylingHold",
        "volume",
        "heatProtection",
        "scalp"
      ],
      "available": true,
      "minPrice": 8.4,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/parisienne_evelonpro_nutri_element_maschera_daily_500ml_bba4b868-bc5c-4fab-8af6-4004dd1d87b9.png?v=1780301716",
        "alt": "Evelon NUTRI ELEMENTS DAILY Pflegemaske Bio-Hafer 500ml Trockenes Haar"
      },
      "caution": false
    },
    {
      "title": "Alkalines Shampoo & Cuticula-Öffner Farbreste Profi-Qualität",
      "url": "/products/alkalines-shampoo-cuticula-oeffner-farbreste-salonbedarf",
      "groups": [
        "cleansing",
        "mask",
        "repair",
        "antiYellow",
        "colorCare",
        "coloring",
        "bleach",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 9.9,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/1707.webp?v=1778508905",
        "alt": "Black Professional Alkalines Shampoo Cuticula-Öffner Farbreste Keratin"
      },
      "caution": true
    },
    {
      "title": "Plex-Protein Treatment & Filler-Effekt Naturbelassenes Haar",
      "url": "/products/plex-protein-treatment-filler-effekt-naturbelassenes-haar",
      "groups": [
        "cleansing",
        "mask",
        "repair",
        "permChemical",
        "stylingHold",
        "curl",
        "scalp",
        "frizzSmoothing"
      ],
      "available": true,
      "minPrice": 109.9,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/dr-kalla-plex-1000-ml-unsere-eigene-keratinglattung-39ddcb654a-drkalla-main-2048_fc1417e3-cc0e-4300-b779-45b5914f33b3.png?v=1780374765",
        "alt": "Plex Protein-Treatment 1000 ml — Kollagen Keratin Milchprotein naturbelassenes Haar"
      },
      "caution": true
    },
    {
      "title": "Oxidationsmittel & Farbentwickler Feinarbeiten Salonqualität",
      "url": "/products/emulgierter-oxidant-farbentwickler-feinarbeiten-salonbedarf",
      "groups": [
        "antiYellow",
        "colorCare",
        "coloring",
        "bleach",
        "developer",
        "permChemical",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 1.08,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/1706.webp?v=1778505753",
        "alt": "Black Professional Emulgierter Oxidant Farbentwickler 250ml Feinarbeiten"
      },
      "caution": true
    },
    {
      "title": "Blond-Tonungscreme & Gelbstich-Neutralisation Friseurbedarf",
      "url": "/products/tonungscreme-gelbstich-neutralisation-balayage-60ml",
      "groups": [
        "repair",
        "antiYellow",
        "colorCare",
        "toner",
        "coloring",
        "bleach",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 9.9,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/Wella-Professionals-Blondor-Cream-Toner--36-60-ml-10727_8_2.webp?v=1779219916",
        "alt": "Wella Blondor Toning Creme 60ml – Tonungscreme für Blonde"
      },
      "caution": true
    },
    {
      "title": "8 in 1 Haar-Ampullen & Kopfhaut-Balance & Kräftigung & Glanz",
      "url": "/products/8-in-1-haar-ampullen-kopfhaut-balance-kraeftigung-glanz",
      "groups": [
        "mask",
        "leaveIn",
        "moisture",
        "repair",
        "stylingHold",
        "scalp",
        "frizzSmoothing"
      ],
      "available": true,
      "minPrice": 12.9,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/FIALE.jpg?v=1780293902",
        "alt": "Evelon Pro 8 in 1 Treatment Haar-Ampullen Kopfhaut-Balance Kräftigung Glanz"
      },
      "caution": false
    },
    {
      "title": "Intensive Nährmaske Trockenes & Sprödes Haar Arganöl 1000ml",
      "url": "/products/intensive-naehrmasken-trockenes-sproedes-haar-arganoel",
      "groups": [
        "cleansing",
        "mask",
        "oilSerum",
        "moisture",
        "repair",
        "stylingHold",
        "frizzSmoothing"
      ],
      "available": true,
      "minPrice": 16.4,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/black-professional-dore-nourishing-argan-oil-mask-1000-ml-aafb8506f7-drkalla-main-2048.png?v=1779205368",
        "alt": "DORÉ Arganöl Haarmaske 1000 ml – Black Professional Line  Professionelle Intensivpflege - Haarpflege"
      },
      "caution": false
    },
    {
      "title": "Plex-Protein Treatment Frizz-Glättung & Filler-Effekt 1000ml",
      "url": "/products/plex-protein-treatment-frizz-glatzung-filler-effekt-coloriertes-haar",
      "groups": [
        "cleansing",
        "mask",
        "moisture",
        "repair",
        "stylingHold",
        "scalp",
        "frizzSmoothing"
      ],
      "available": true,
      "minPrice": 109.9,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/dr-kalla-plex-1000-ml-unsere-eigene-keratinglattung-39ddcb654a-drkalla-main-2048.png?v=1779205778",
        "alt": "Dr.Kalla Plex Keratin Treatment – Haar Glättung & Filler mit Kollagen und Vitamin E - Styling"
      },
      "caution": false
    },
    {
      "title": "Extra Hold Haargel & Volumen Super Stark Feuchtigkeit",
      "url": "/products/extra-hold-haargel-super-stark-volumen",
      "groups": [
        "mask",
        "moisture",
        "stylingHold",
        "volume",
        "curl",
        "frizzSmoothing"
      ],
      "available": true,
      "minPrice": 1.19,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/44463240_2.webp?v=1779434258",
        "alt": "Extra Hold Styling Gel Super Stark Volumen 350ml"
      },
      "caution": false
    },
    {
      "title": "Klärendes Frucht-Shampoo & Brennnessel & Ölausgleich 1000ml",
      "url": "/products/klaerndes-frucht-shampoo-oelausgleich-1000ml",
      "groups": [
        "cleansing",
        "moisture",
        "repair",
        "bleach",
        "stylingHold",
        "scalp"
      ],
      "available": true,
      "minPrice": 2.5,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/Screenshot2026-06-01072215.jpg?v=1780287827",
        "alt": "Parisienne Klärendes Frucht-Shampoo 1000ml mit Brennnessel-Extrakt fettiges Haar"
      },
      "caution": true
    },
    {
      "title": "Stärkende Pflegespülung & Haarregeneration mit Gelée Royale",
      "url": "/products/staerkende-pflegespuelung-haarregeneration-gelee-royale-1000ml",
      "groups": [
        "conditioner",
        "moisture",
        "repair",
        "coloring",
        "bleach",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 2.5,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/Balsam-tonifiant-pentru-par-slabit-Evelon-PARISIENNE-1000-ml-PAR100002-1.jpg?v=1773635960",
        "alt": "Evelon Pro Stärkende Pflegespülung 1000ml Gelée Royale Haarregeneration"
      },
      "caution": true
    },
    {
      "title": "Colorationscreme Haarfarbe & Grauabdeckung Profi-Salonbedarf",
      "url": "/products/colorationscreme-haarfarbe-grauabdeckung-salonbedarf",
      "groups": [
        "antiYellow",
        "colorCare",
        "coloring",
        "bleach",
        "permChemical",
        "scalp"
      ],
      "available": true,
      "minPrice": 2.99,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/clair_fontaine_color_cream.webp?v=1778484371",
        "alt": "Colorationscreme Haarfarbe Grauabdeckung – Verpackung & Produkt"
      },
      "caution": true
    },
    {
      "title": "Trockenshampoo Keratin & Arganöl Express-Reinigung Volumen",
      "url": "/products/trockenshampoo-express-reinigung-ohne-wasser",
      "groups": [
        "cleansing",
        "leaveIn",
        "moisture",
        "repair",
        "stylingHold",
        "volume"
      ],
      "available": true,
      "minPrice": 3.2,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/black_professional_line_styling_express_beauty_shampoo_secco_300ml.png?v=1779678995",
        "alt": "Black Professional Line Trockenshampoo Express Beauty 200ml"
      },
      "caution": false
    },
    {
      "title": "Tonungsaktivator Gelbstich-Neutralisation & Kaltblond Profi",
      "url": "/products/tonungsaktivator-gelbstich-neutralisation-kaltblond-salonbedarf",
      "groups": [
        "antiYellow",
        "colorCare",
        "toner",
        "coloring",
        "bleach",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 4.49,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/1017.webp?v=1778507741",
        "alt": "Black Professional Tonungsaktivator Gelbstich-Neutralisation Kaltblond"
      },
      "caution": true
    },
    {
      "title": "Haarfarbe Ammoniakfrei & Kamille Coloration Profi-Qualität",
      "url": "/products/haarfarbe-ammoniakfrei-kamille-coloration-salonbedarf",
      "groups": [
        "colorCare",
        "coloring",
        "bleach",
        "permChemical",
        "stylingHold",
        "scalp"
      ],
      "available": true,
      "minPrice": 4.5,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/tinta-senza-ammoniaca-di-herfit-100-ml.webp?v=1778496339",
        "alt": "Ammoniakfreie Haarfarbe mit Kamille – Verpackung & Produkt"
      },
      "caution": true
    },
    {
      "title": "Herfit Pro Multivitamins 100 ml Professionelle Haarfarbe Colorations Färbecreme",
      "url": "/products/herfit-pro-multivitamins-100-ml",
      "groups": [
        "repair",
        "antiYellow",
        "colorCare",
        "coloring",
        "bleach",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 4.5,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/XIm_dd9704e8-80ae-47b3-a899-6b5ae5262668.png?v=1773653707",
        "alt": "Herfit Pro Multivitamins 100 ml Professionelle Haarfarbe Colorations Färbecreme"
      },
      "caution": true
    },
    {
      "title": "Spray Conditioner & Feuchtigkeit & Haarbruch-Schutz 200ml",
      "url": "/products/spray-conditioner-feuchtigkeit-haarbruch-schutz-200ml",
      "groups": [
        "conditioner",
        "leaveIn",
        "moisture",
        "repair",
        "stylingHold",
        "volume"
      ],
      "available": true,
      "minPrice": 5.9,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/dual-action-spray-conditioner-200-ml-black-professional-line-8a186d1edf-drkalla-main-2048.png?v=1779202119",
        "alt": "Black Professional Line Volumen Conditioner 200 ml – mit Vitamin E & Panthenol - Haarpflege"
      },
      "caution": false
    },
    {
      "title": "Blond Booster & Gelb-Neutralisation für kühle Brillanz",
      "url": "/products/blond-booster-gelb-neutralisation-kuehle-brillanz",
      "groups": [
        "leaveIn",
        "antiYellow",
        "colorCare",
        "coloring",
        "bleach",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 6.4,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/no-yellow-absolute-blond-booster-4030fab35e-drkalla-main-2048.png?v=1779202155",
        "alt": "BLACK Professional Line – Platinum No Yellow Booster - Haarfarbe und Blondierung"
      },
      "caution": true
    },
    {
      "title": "Farbentwickler Oxidationsmittel & Aufhellung Profi-Salonbedarf",
      "url": "/products/farbentwickler-oxidationsmittel-aufhellung-salonbedarf",
      "groups": [
        "antiYellow",
        "colorCare",
        "coloring",
        "bleach",
        "developer",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 6.69,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/122.webp?v=1778498770",
        "alt": "Wella Welloxon Perfect Entwickler 12% Aufhellung"
      },
      "caution": true
    },
    {
      "title": "Black Professional Line Curly Dream Lockencreme 150 ml – mit Bio-Baobaböl & Rose",
      "url": "/products/amplifier-cream-150-ml",
      "groups": [
        "mask",
        "moisture",
        "repair",
        "stylingHold",
        "curl",
        "frizzSmoothing"
      ],
      "available": true,
      "minPrice": 6.9,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/amplifier-cream-150-ml-67fbf56cee-drkalla-main-2048.png?v=1779202054",
        "alt": "Black Professional Line Curly Dream Lockencreme 150 ml – mit Bio-Baobaböl & Rose - Styling"
      },
      "caution": false
    },
    {
      "title": "Anti-Yellow Shampoo & Gelb-Neutralisation für blondiertes Haar",
      "url": "/products/anti-yellow-shampoo-gelb-neutralisation-sulfatfrei",
      "groups": [
        "cleansing",
        "moisture",
        "colorCare",
        "antiYellow",
        "coloring",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 8,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/black_professional_line_platinum_shampoo_1000ml_no_yellowSITO.jpg?v=1780126939",
        "alt": "Black Professional Line Platinum No Yellow Shampoo 1000ml"
      },
      "caution": true
    },
    {
      "title": "Detox Haarmaske & Bio-Ingwer-Extrakt & Tiefenreinigung 500ml",
      "url": "/products/detox-haarmaske-bio-ingwer-extrakt-tiefenreinigung-500ml",
      "groups": [
        "cleansing",
        "mask",
        "moisture",
        "repair",
        "stylingHold",
        "scalp"
      ],
      "available": true,
      "minPrice": 8.4,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/parisienne_evelonpro_nutri_element_maschera_detox_500ml.png?v=1780289355",
        "alt": "Evelon Pro Detox Haarmaske mit Bio-Ingwer-Extrakt 500ml Tiefenreinigung"
      },
      "caution": false
    },
    {
      "title": "Glättendes Shampoo & Anti-Frizz Spliss Vorbeugen",
      "url": "/products/glaettendes-shampoo-anti-frizz-bio-baobaboel-spliss-vorbeugen",
      "groups": [
        "cleansing",
        "oilSerum",
        "moisture",
        "repair",
        "stylingHold",
        "frizzSmoothing"
      ],
      "available": true,
      "minPrice": 8.4,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/parisienne_evelonpro_nutri_element_shampoo_total_control_500ml-1_6534aef8-06b1-4efa-8d0b-3382fc81a8d0.png?v=1780030948",
        "alt": "Evelon Pro Smoothing Shampoo Anti-Frizz 500 ml Bio-Baobaböl Glättend"
      },
      "caution": false
    },
    {
      "title": "Transparente Flüssigkristalle & Leinöl Cuticle-Versiegelung",
      "url": "/products/transparente-flussigkristalle-leinol-cuticle-versiegelung",
      "groups": [
        "oilSerum",
        "moisture",
        "repair",
        "coloring",
        "stylingHold",
        "frizzSmoothing"
      ],
      "available": true,
      "minPrice": 8.4,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/black_professional_line_trating_cristalli_liquidi_trasparenti_100ml.png?v=1780310583",
        "alt": "Black Professional Line Transparent Flaxseed Crystals 100 ml — Leinöl Haarkristalle"
      },
      "caution": true
    },
    {
      "title": "Klärende Pflegespülung & Ölausgleich & Fettiges Haar 1000ml",
      "url": "/products/klaernde-pflegespuelung-oelausgleich-fettiges-haar-1000ml",
      "groups": [
        "cleansing",
        "conditioner",
        "moisture",
        "repair",
        "stylingHold",
        "scalp"
      ],
      "available": true,
      "minPrice": 8.9,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/Screenshot2026-06-01075316.jpg?v=1780290034",
        "alt": "Evelon Pro Essence Pure Pflegespülung 1000ml klärend fettiges Haar"
      },
      "caution": false
    },
    {
      "title": "Repair-Haarmaske mit Keratin & Feuchtigkeit für geschädigtes Haar",
      "url": "/products/repair-haarmaske-keratin-parisienne-technologie-geschadigtes-haar-1000ml",
      "groups": [
        "mask",
        "moisture",
        "repair",
        "coloring",
        "bleach",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 8.9,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/evelon_psn_essense_repair_maschera_idratante_cheratina_1000ml.png?v=1773635725",
        "alt": "Evelon Pro PSN Essence Repair Mask 1000ml Keratin Parisienne Technologie"
      },
      "caution": true
    },
    {
      "title": "Regenerierendes Haarserum & Arganöl Spirulina Spliss-Schutz",
      "url": "/products/regenerierendes-haarserum-arganol-spirulina-spliss-schutz",
      "groups": [
        "leaveIn",
        "oilSerum",
        "moisture",
        "repair",
        "stylingHold",
        "frizzSmoothing"
      ],
      "available": true,
      "minPrice": 9.9,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/img_c10f13c5-4a23-467d-b0a4-fe13064127aa.jpg?v=1780306653",
        "alt": "Black Professional Line Doré Regenerating Serum 50 ml — Arganöl & Spirulina Haarserum"
      },
      "caution": false
    },
    {
      "title": "Farbschutz-Conditioner",
      "url": "/products/farbschutz-conditioner",
      "groups": [
        "conditioner",
        "moisture",
        "colorCare",
        "coloring",
        "bleach",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 10,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/47A48570-DEE7-4600-BF17-AA43484AFF6D.jpg?v=1773585172",
        "alt": "Farbschutz-Conditioner"
      },
      "caution": true
    },
    {
      "title": "Farbschutzshampoo",
      "url": "/products/farbschutzshampoo",
      "groups": [
        "cleansing",
        "moisture",
        "repair",
        "colorCare",
        "coloring",
        "bleach"
      ],
      "available": true,
      "minPrice": 12,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/C947CE7F-5A38-4303-AB49-5EF7BD30E158.jpg?v=1773585128",
        "alt": "Farbschutzshampoo"
      },
      "caution": true
    },
    {
      "title": "Oxidationsmittel & Farbentwickler Coloration Profi-Qualität",
      "url": "/products/oxidationsmittel-farbentwickler-coloration-salonbedarf",
      "groups": [
        "antiYellow",
        "colorCare",
        "coloring",
        "bleach",
        "developer",
        "permChemical"
      ],
      "available": true,
      "minPrice": 12.5,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/6705.webp?v=1778504119",
        "alt": "Herfit Pro Oxidant Farbentwickler Blondierung 5000ml Salonqualität"
      },
      "caution": true
    },
    {
      "title": "Haarstyling-Werkzeuge, Haarfärbeschale für Friseursalon und Zuhause",
      "url": "/products/hair-styling-tools-hair-coloring-bowl-for-barbershop-and-home",
      "groups": [
        "cleansing",
        "antiYellow",
        "colorCare",
        "coloring",
        "bleach",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 14.11,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/b1425cd6-e364-46ab-95cf-392cb1112fe9.jpg?v=1770837003",
        "alt": "Haarstyling-Werkzeuge, Haarfärbeschale für Friseursalon und Zuhause"
      },
      "caution": true
    },
    {
      "title": "Regenerierende Haarmaske & Keratin Frizz-Glättung 1000ml",
      "url": "/products/regenerierende-haarmaske-keratin-frizz-glaettung-1000ml",
      "groups": [
        "cleansing",
        "mask",
        "moisture",
        "repair",
        "stylingHold",
        "frizzSmoothing"
      ],
      "available": true,
      "minPrice": 14.4,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/00000257P_jpg_1.webp?v=1779695786",
        "alt": "Black Professional Line PERLÉ Regenerating Mask 1000ml Keratin Frizz Glättung"
      },
      "caution": false
    },
    {
      "title": "Farbschutz Maske & Farbbrillanz Farbverschiebung Schützen",
      "url": "/products/farbschutz-maske-farbbrillanz-farbverschiebung-auswaschung-schuetzen",
      "groups": [
        "cleansing",
        "mask",
        "moisture",
        "repair",
        "colorCare",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 14.9,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/11803300644.jpg?v=1780069694",
        "alt": "Wella SP Color Save Farbschutz Maske 400 ml Farbbrillanz Geschmeidigkeit"
      },
      "caution": false
    },
    {
      "title": "Ammoniakfreie duftende Dauerwellenlösung 500ml",
      "url": "/products/ammoniakfreie-duftende-dauerwellenlosung-light",
      "groups": [
        "cleansing",
        "moisture",
        "permChemical",
        "stylingHold",
        "curl",
        "scalp"
      ],
      "available": true,
      "minPrice": 16,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/rn-image_picker_lib_temp_d311dea1-5ecd-4603-bba5-a88dcdb3640b.png?v=1773576927",
        "alt": "Ammoniakfreie duftende Dauerwellenlösung 500ml"
      },
      "caution": true
    },
    {
      "title": "Blondierungspulver 10 Töne Keratin-Formel & Aufhellung Profi",
      "url": "/products/blondierungspulver-keratin-formel-maximale-aufhellung",
      "groups": [
        "repair",
        "antiYellow",
        "colorCare",
        "coloring",
        "bleach",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 17.9,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/black_professional_line_bleaching_polvere_decolorante_10_toni_500g_busta-scaled_e683736c-b7f3-4086-bd0e-3c319f8a3ee7.webp?v=1778590139",
        "alt": "Black-Ultralift 10 Blondierungspulver 500g Keratin-Formel Profi"
      },
      "caution": true
    },
    {
      "title": "Glacier Pour Homme Herrenparfum EDP 100 ml – Frisch & Maskulin",
      "url": "/products/glacier-for-men-3-4-oz-edp-spray",
      "groups": [
        "mask",
        "moisture",
        "repair",
        "antiYellow",
        "colorCare",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 19.9,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/b2a9d5f5-82cf-4e35-bb7c-8a1763ec3d68.jpg?v=1769709830",
        "alt": "Glacier Pour Homme Herrenparfum EDP 100 ml – Frisch & Maskulin"
      },
      "caution": false
    },
    {
      "title": "Blondierungspulver Bond-Schutz Aufhellung Dunkles Haar Profi",
      "url": "/products/blondierungspulver-bond-schutz-aufhellung-dunkles-haar",
      "groups": [
        "repair",
        "antiYellow",
        "colorCare",
        "coloring",
        "bleach",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 24.19,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/decolorante-9-toni-blonde-me-articoli-per-parrucchieri-benatural-store-torino-prodotti-per-capelli-600x600_12a4f338-72f6-40c2-8467-22c90a3e1d47.webp?v=1778587617",
        "alt": "BlondME Premium Blondierungspulver 450g Schwarzkopf Bond-Schutz"
      },
      "caution": true
    },
    {
      "title": "Blondierungspulver Bond-Schutz & Kühler Lift Profi-Qualität",
      "url": "/products/blondierungspulver-bond-schutz-kuehler-lift-profi",
      "groups": [
        "repair",
        "antiYellow",
        "colorCare",
        "coloring",
        "bleach",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 31.9,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/Wella_BlondorPlex_9_Blondierungspulver_800g_Bond-Schutz_Profi.webp?v=1778922626",
        "alt": "Wella BlondorPlex 9 Blondierungspulver 800g Bond-Schutz Profi"
      },
      "caution": true
    },
    {
      "title": "Purifying Haarbalsam & Tiefenreinigung & Seidiger Glanz 1000ml",
      "url": "/products/purifying-haarbalsam-tiefenreinigung-seidiger-glanz-1000ml",
      "groups": [
        "cleansing",
        "conditioner",
        "moisture",
        "repair",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 2.49,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/parisienne_professional_balsamo_purificante_1000ml_826fae12-17b1-4384-ac4c-7ea3c8712332.png?v=1780290985",
        "alt": "Evelon Pro Purifying Haarbalsam 1000ml klärend Unreinheiten entfernen"
      },
      "caution": false
    },
    {
      "title": "Flüssigkristalle & Leinöl Arganöl Cuticle-Glättung Glanz Haar",
      "url": "/products/flussigkristalle-leinol-arganol-cuticle-glatzung-glanz",
      "groups": [
        "oilSerum",
        "moisture",
        "repair",
        "stylingHold",
        "frizzSmoothing"
      ],
      "available": true,
      "minPrice": 5.2,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/evelon_cristalli_fluidi_semi_di_lino_100ml_e5e3fe2d-2701-4884-861e-b1ce175168c0.png?v=1780317101",
        "alt": "Evelon Pro CRS Fluid Crystals 100 ml — Leinöl & Arganöl Glanzkristalle"
      },
      "caution": false
    },
    {
      "title": "Färbeschäum Dunkelblond & Grauabdeckung Demi-Permanent",
      "url": "/products/farbeschaeum-dunkelblond-grauabdeckung-demi-permanent",
      "groups": [
        "leaveIn",
        "coloring",
        "bleach",
        "permChemical",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 5.4,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/img_f85abaa1-d49b-485a-a373-117fe3b3ea74.webp?v=1779429055",
        "alt": "Rosocosmetics Färbeschäum Dunkelblond 200ml Color Mousse Grauabdeckung"
      },
      "caution": true
    },
    {
      "title": "Klärendes Haarshampoo & Fettige Kopfhaut & Tiefenreinigung",
      "url": "/products/klaerndes-shampoo-fettige-kopfhaut-talgregulation-brennnessel",
      "groups": [
        "cleansing",
        "moisture",
        "repair",
        "stylingHold",
        "scalp"
      ],
      "available": true,
      "minPrice": 5.9,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/purifying-shampoo-1000-ml-black-professional-line-ffe57f399f-drkalla-main-2048.png?v=1779202098",
        "alt": "Black Professional Line Purifying Shampoo 1000 ml – für fettiges Haar - Haarpflege"
      },
      "caution": false
    },
    {
      "title": "Farbschutz Maske & Entwirrende Pflege für coloriertes Haar",
      "url": "/products/farbschutz-maske-entwirrende-pflege-coloriertes-haar",
      "groups": [
        "mask",
        "moisture",
        "repair",
        "colorCare",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 6.9,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/maska-do-wlosow-po-koloryzacji-clr-post-colour-500ml-evelon-pro.jpg?v=1780112988",
        "alt": "Evelon Pro Farbschutz Maske 500ml für coloriertes Haar"
      },
      "caution": false
    },
    {
      "title": "Haarglanz & Leinöl Schutz Blue Liquid Crystals Normales Haar",
      "url": "/products/glanzschutz-leinol-normales-haar-blue-liquid-crystals",
      "groups": [
        "leaveIn",
        "oilSerum",
        "moisture",
        "repair",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 6.9,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/parisienne_cristalli_fluidi_blu_50ml_942a324f-615d-4e69-b6a4-6beed8746296.png?v=1780309272",
        "alt": "Parisienne Evelon Blue Liquid Crystals 50 ml — Glanz-Schutz mit Leinöl für normales Haar"
      },
      "caution": false
    },
    {
      "title": "Klärendes Shampoo & Tiefenreinigung & Talgregulation 1000ml",
      "url": "/products/klaerndes-shampoo-tiefenreinigung-talgregulation-1000ml",
      "groups": [
        "cleansing",
        "moisture",
        "repair",
        "stylingHold",
        "scalp"
      ],
      "available": true,
      "minPrice": 7.5,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/Screenshot2026-06-01072807.jpg?v=1780288635",
        "alt": "Evelon Pro Klärendes Shampoo Essence Pure 1000ml Tiefenreinigung fettige Kopfhaut"
      },
      "caution": false
    },
    {
      "title": "Rose Curly Dream – Modelliercreme mit biologischem Baobab-Öl",
      "url": "/products/rose-curly-dream-modelliercreme-mit-biologischem-baobab-ol",
      "groups": [
        "moisture",
        "repair",
        "stylingHold",
        "curl",
        "scalp"
      ],
      "available": true,
      "minPrice": 7.5,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/12BFA506-3F6F-4BAA-9601-06DDEA7FB4D4.jpg?v=1773584523",
        "alt": "Rose Curly Dream – Modelliercreme mit biologischem Baobab-Öl"
      },
      "caution": false
    },
    {
      "title": "Anti-Orange Shampoo & Orangestich-Korrektur für dunkelblondes Haar",
      "url": "/products/anti-orange-shampoo-orangestich-korrektur-dunkelblond",
      "groups": [
        "cleansing",
        "moisture",
        "antiYellow",
        "colorCare",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 8,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/black_professional_line_platinum_shampoo_1000ml_no_orangeSITO-600x600.jpg?v=1780130560",
        "alt": "Black Professional Line No Orange Shampoo 1000ml"
      },
      "caution": false
    },
    {
      "title": "Anti-Frizz Haarmaske & Geschmeidigkeit Elastizität",
      "url": "/products/anti-frizz-haarmaske-geschmeidigkeit-elastizitaet-arganoel",
      "groups": [
        "mask",
        "moisture",
        "repair",
        "stylingHold",
        "frizzSmoothing"
      ],
      "available": true,
      "minPrice": 8.4,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/maska-do-wlosow-puszacych-total-control-nutri-elements-500ml-evelon-pro.jpg?v=1780029934",
        "alt": "Evelon Pro Nutri Elements Anti-Frizz Haarmaske 500 ml Seidenproteine Arganöl"
      },
      "caution": false
    },
    {
      "title": "Detox Shampoo Tiefenreinigung & Kopfhaut-Balance Nachfetten",
      "url": "/products/detox-shampoo-tiefenreinigung-kopfhaut-balance",
      "groups": [
        "cleansing",
        "moisture",
        "repair",
        "stylingHold",
        "scalp"
      ],
      "available": true,
      "minPrice": 8.4,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/nutri-elements-detox-shampoo-500-ml.webp?v=1780158046",
        "alt": "Evelon Pro NutriElements Detox Shampoo Tiefenreinigung 500ml"
      },
      "caution": false
    },
    {
      "title": "Leinöl Flüssigkristalle & Glanzschutz Spliss-Regeneration Haar",
      "url": "/products/leinol-flussigkristalle-glanzschutz-spliss-regeneration",
      "groups": [
        "oilSerum",
        "moisture",
        "repair",
        "stylingHold",
        "frizzSmoothing"
      ],
      "available": true,
      "minPrice": 8.4,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/black_professional_line_trating_cristalli_liquidi_100ml.png?v=1780309986",
        "alt": "Black Professional Line Flaxseed Liquid Crystals 100 ml — Leinöl Glanzschutz"
      },
      "caution": false
    },
    {
      "title": "Nährendes Shampoo & Sanfte Reinigung Feines Haar Bio-Hafer",
      "url": "/products/nahrendes-shampoo-sanfte-reinigung-feines-haar-bio-hafer",
      "groups": [
        "cleansing",
        "moisture",
        "repair",
        "stylingHold",
        "scalp"
      ],
      "available": true,
      "minPrice": 8.4,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/parisienne_evelonpro_nutri_element_shampoo_daily_500ml-1_7cce9bf7-3797-40e8-8020-5ce44caaa8c1.png?v=1780304044",
        "alt": "Evelon NUTRI ELEMENTS DAILY Frequent Use Shampoo 500 ml — Sanftes Shampoo mit Bio-Hafer"
      },
      "caution": false
    },
    {
      "title": "Laminier-Spray B3-PLEX Keravis Ceramide Hitzeschutz Leave-in",
      "url": "/products/laminier-spray-b3-plex-keravis-ceramide-hitzeschutz-leave-in",
      "groups": [
        "leaveIn",
        "stylingHold",
        "heatProtection",
        "curl",
        "frizzSmoothing"
      ],
      "available": true,
      "minPrice": 8.9,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/77405.jpg?v=1779889445",
        "alt": "Black Professional Line ARGENT Laminating Spray 200ml B3-PLEX Ceramide"
      },
      "caution": false
    },
    {
      "title": "Revitalisierende Haarmaske & Sofortiger Glanz Vitalität",
      "url": "/products/revitalisierende-haarmaske-kraftloses-haar-gelee-royale-1000ml",
      "groups": [
        "mask",
        "moisture",
        "repair",
        "stylingHold",
        "heatProtection"
      ],
      "available": true,
      "minPrice": 9.9,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/xanitalia-kauke-normaliems-plaukams-su-pieno-baltymais-herfit-pro-1000-ml-1.jpg?v=1780033725",
        "alt": "Herfit Pro Discipline Revitalisierende Haarmaske 1000 ml Gelée Royale"
      },
      "caution": false
    },
    {
      "title": "Blanc Volume Up – Volumising Maske",
      "url": "/products/blanc-volume-up-volumising-maske",
      "groups": [
        "cleansing",
        "mask",
        "moisture",
        "repair",
        "volume"
      ],
      "available": true,
      "minPrice": 10,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/372777F1-E064-416D-AAFD-82C369B1D8C3.jpg?v=1773585338",
        "alt": "Blanc Volume Up – Volumising Maske"
      },
      "caution": false
    },
    {
      "title": "Leave-in-Conditioner mit doppelter Wirkung",
      "url": "/products/leave-in-conditioner-mit-doppelter-wirkung",
      "groups": [
        "conditioner",
        "leaveIn",
        "moisture",
        "repair",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 10,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/E33B0D7D-85D9-4EB2-948D-0343FEDC1C47.jpg?v=1773586033",
        "alt": "Leave-in-Conditioner mit doppelter Wirkung"
      },
      "caution": false
    },
    {
      "title": "Talgausgleichender Conditioner \nfür fettiges Haar",
      "url": "/products/talgausgleichender-conditioner-fur-fettiges-haar",
      "groups": [
        "conditioner",
        "moisture",
        "repair",
        "scalp",
        "frizzSmoothing"
      ],
      "available": true,
      "minPrice": 15,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/75E05055-B862-46C5-B097-C57D9C3F0AE4.jpg?v=1773629911",
        "alt": "Talgausgleichender Conditioner \nfür fettiges Haar"
      },
      "caution": false
    },
    {
      "title": "Blondierungspulver Blau & Aufhellung Salonbedarf Barbershop",
      "url": "/products/blondierungspulver-blau-aufhellung-friseurbedarf",
      "groups": [
        "bleach",
        "developer",
        "stylingHold",
        "volume"
      ],
      "available": true,
      "minPrice": 0.99,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/4-scaled_40e6a1d6-b2f5-46f9-ad44-b12250347efe.webp?v=1779188169",
        "alt": "Black Professional Blondierungspulver Blau Portionsbeutel Schachtel"
      },
      "caution": true
    },
    {
      "title": "Hitzeschutz & Anti-Frizz Glätteisen Stylingtools 200ml",
      "url": "/products/hitzeschutz-anti-frizz-glaetteisen-stylingtools-200ml",
      "groups": [
        "stylingHold",
        "heatProtection",
        "curl",
        "frizzSmoothing"
      ],
      "available": true,
      "minPrice": 8,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/rn-image_picker_lib_temp_3def669f-996d-4c56-a9a3-40f7fd040576.webp?v=1779685793",
        "alt": "Black Professional Line Heat Protection Hitzeschutz Spray 200ml"
      },
      "caution": false
    },
    {
      "title": "Tönung Semi-permanent & Farbcreme Ammoniakfrei Friseurbedarf",
      "url": "/products/semipermanente-tonung-ammoniakfrei-farbcreme-300ml",
      "groups": [
        "toner",
        "coloring",
        "permChemical",
        "stylingHold"
      ],
      "available": true,
      "minPrice": 12.99,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/black_professional_crazy_toner_pink_bomb.webp?v=1779256045",
        "alt": "Black Professional Crazy Toner Pink Bomb – Semipermanente Tönung 300ml"
      },
      "caution": true
    },
    {
      "title": "Volumen Styling-Schaum & Extra Hold Hitzeschutz Föhnen 300ml",
      "url": "/products/volumen-styling-schaum-extra-hold-hitzeschutz-300ml",
      "groups": [
        "stylingHold",
        "volume",
        "heatProtection"
      ],
      "available": true,
      "minPrice": 9.99,
      "image": {
        "src": "https://cdn.shopify.com/s/files/1/0777/9680/2900/files/images_2.webp?v=1779428987",
        "alt": "Wella EIMI Extra Volume Mousse 300ml Volumen Styling-Schaum Hitzeschutz"
      },
      "caution": false
    }
  ],
  "useCases": []
};
